import { render, staticRenderFns } from "./AdminBookingsAwaitingPaperwork.vue?vue&type=template&id=6c0c0ef4"
import script from "./AdminBookingsAwaitingPaperwork.vue?vue&type=script&lang=js"
export * from "./AdminBookingsAwaitingPaperwork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports